import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { userLoggedIn } from "../Features/auth/authSlice";
import { getAllUsers } from "../Features/users/UserSlice";

export default function useAuthCheck() {
    const dispatch = useDispatch();
    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        const localAuth = localStorage?.getItem("auth");
        const localUsers = localStorage?.getItem("users");

        if (localAuth && localUsers) {
            const users = JSON.parse(localUsers);
            const auth = JSON.parse(localAuth);
            if (users) {
                dispatch(getAllUsers(users));
            }
            if (auth?.accessToken && auth?.user) {
                dispatch(
                    userLoggedIn({
                        accessToken: auth.accessToken,
                        user: auth.user,
                    })
                );
            }
        }
        setAuthChecked(true);
    }, [dispatch, setAuthChecked]);

    return authChecked;
}
